import React, { useState } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Outlet,
  Navigate,
} from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Header from "./components/common/Header";
import OffCanvasSidebar from "./components/common/OffCanvasSidebar";
import Sidebar from "./components/common/Sidebar";
import PageNotFound from "./components/common/PageNotFound";
import ChemicalRecipes from "./components/chemicalRecipes/ChemicalRecipes";
import SiteRegistration from "./components/siteRegistration/SiteRegistration";
import MySitesScreens from "./components/mySites/MySitesScreens";
import Sites from "./components/mySites/sites/Sites";
import PlantedAcres from "./components/mySites/plantedAcres/PlantedAcres";
import RecipeUsage from "./components/mySites/recipeUsage/RecipeUsage";
import Login from "./components/user/Login";
import Registration from "./components/user/registration/Registration";
import Profile from "./components/user/profile/Profile";
import { useActiveLink } from "hooks/useActiveLink";
import "./App.css";
import { LOCAL_STORAGE_KEYS } from "configurations/Constants";

const AppContent = ({ showSidebar, handleShowSidebar, handleCloseSidebar }) => {
  useActiveLink();
  return (
    <Routes>
      <Route path="/" element={<Navigate to="/site-registration" replace />} />
      <Route path="/login" element={<Login />} />
      <Route
        element={
          <SidebarLayout
            header={
              <Header
                handleShowSidebar={handleShowSidebar}
                showSidebar={showSidebar}
              />
            }
            showSidebar={showSidebar}
            handleCloseSidebar={handleCloseSidebar}
          />
        }
      >
        <Route path="/sites" element={<MySitesScreens />}>
          <Route index element={<Sites />} />
          <Route path=":siteId/planted-acres" element={<PlantedAcres />} />
          <Route
            path=":siteId/planted-acres/:plantedAcresId"
            element={<RecipeUsage />}
          />
        </Route>
        <Route path="/site-registration" element={<SiteRegistration />} />
        <Route path="/recipes" element={<ChemicalRecipes />} />
        <Route path="/profile" element={<Profile />} />
      </Route>
      <Route path="/registration" element={<Registration />} />
      <Route path="*" element={<PageNotFound />} />
    </Routes>
  );
};

const SidebarLayout = ({ header, showSidebar, handleCloseSidebar }) => {
  const token = localStorage.getItem(LOCAL_STORAGE_KEYS.ID_TOKEN);
  if (!token) return <Navigate to="/login" replace />;
  return (
    <div>
      {header}
      <div className="d-flex">
        <OffCanvasSidebar
          showSidebar={showSidebar}
          handleCloseSidebar={handleCloseSidebar}
        />
        <div className="d-none d-lg-flex flex-column border-end sidebar">
          <Sidebar handleCloseSidebar={() => {}} expandable={true} />
        </div>
        <Outlet />
      </div>
    </div>
  );
};

function App() {
  const [showSidebar, setShowSidebar] = useState(false);
  const handleCloseSidebar = () => setShowSidebar(false);
  const handleShowSidebar = () => setShowSidebar(true);

  return (
    <Router>
      <AppContent
        showSidebar={showSidebar}
        handleShowSidebar={handleShowSidebar}
        handleCloseSidebar={handleCloseSidebar}
      />
      <ToastContainer
        position="top-right"
        autoClose={3000}
        closeOnClick
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </Router>
  );
}

export default App;
